import { WizardPanel } from '@main/ad-core-components';
import { Img } from '@main/core-ui';
import { ASSET_BASE_URL } from '@main/utils';
import React from 'react';
import { useIntl } from 'react-intl';

import { notFoundMessages } from './messages';

/**
 * Not found props
 */
export interface NotFoundProps {
  /** The src of the not found image */
  imgSrc?: string;
}

/**
 * The Not Found Page, displayed when a page is not found
 */
export const NotFound: React.FC<NotFoundProps> = ({
  imgSrc = `${ASSET_BASE_URL}/not-found.svg`,
}) => {
  const { formatMessage } = useIntl();
  return (
    <WizardPanel showTranscendLogo title={notFoundMessages.title}>
      <Img
        src={imgSrc}
        width="100%"
        style={{ margin: '70px 0', maxHeight: '404px' }}
        alt={formatMessage(notFoundMessages.alt)}
      />
    </WizardPanel>
  );
};

export default NotFound;
